import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { SafeResourceUrl } from '@angular/platform-browser';
import { TranslatePipe } from '@ngx-translate/core';

import { ModalComponent } from '../../../shared/components/modal/modal/modal.component';
import { LoaderComponent } from '../../../shared/loader/loader.component';
import { LegalDocumentType } from '../../model/LegalDocumentType';

@Component({
    selector: 'app-sign-legal-document-modal',
    imports: [ModalComponent, LoaderComponent, TranslatePipe],
    templateUrl: './sign-legal-document-modal.component.html',
    styleUrl: './sign-legal-document-modal.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SignLegalDocumentModalComponent {
    readonly open = input<boolean>(false);
    readonly documentType = input<LegalDocumentType>();
    readonly documentUrl = input<SafeResourceUrl>();
    readonly loading = input<boolean>(false);

    readonly confirmed = output<void>();
}
